import React, { useCallback, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ItemContent, ItemTitle } from '../DarkWebStyles';
import { deleteEmail } from '../../../../ExperianActions';
import { DataItem, DataItemText, DeleteIcon } from '../DarkWebModal/DarkWebModalStyles';
import StopMonitoringModal from '../StopMonitoringModal/StopMonitoringModal';
import { PRIMARY_EMAIL_LABEL } from '../DarkWebConstants';
import ExperianContext from '../../../../ExperianContext';

const EmailAddresses = ({ title, data }) => {
  const [emailToDelete, setEmailToDelete] = useState(null);

  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  const onConfirmCallback = useCallback(async () => {
    await dispatch(deleteEmail(clientId, subscriberId, emailToDelete.Label));
    setEmailToDelete(null);
  }, [clientId, subscriberId, emailToDelete, dispatch]);

  return (
    data &&
    data.length > 0 && (
      <>
        <div>
          <ItemTitle>{title}</ItemTitle>
          <ItemContent>
            {data.map(email => (
              <DataItem key={email.Label}>
                {email.Label !== PRIMARY_EMAIL_LABEL && (
                  <DeleteIcon onClick={() => setEmailToDelete(email)} />
                )}
                <DataItemText>{email.Address}</DataItemText>
              </DataItem>
            ))}
          </ItemContent>
        </div>
        {!!emailToDelete && (
          <StopMonitoringModal
            onConfirm={onConfirmCallback}
            onRequestClose={() => setEmailToDelete(null)}
          >
            Are you sure you want to stop monitoring:
            <br />
            Email address {emailToDelete.Address}?
          </StopMonitoringModal>
        )}
      </>
    )
  );
};

export default EmailAddresses;
